const GTM_JS_URL_PREFIX = 'https://www.googletagmanager.com/gtm.js?id=';

const GTM_CONSENT_DEFAULT_SCRIPT_LINES = [
  'function gtag(){dataLayer.push(arguments);}',
  "gtag('consent', 'default', {",
  "  'ad_storage': 'denied',",
  "  'ad_user_data': 'denied',",
  "  'ad_personalization': 'denied',",
  "  'analytics_storage': 'denied',",
  "  'functionality_storage': 'denied',",
  "  'personalization_storage': 'denied',",
  "  'security_storage': 'granted',",
  "  'wait_for_update': 500",
  '});',
  "gtag('set', 'ads_data_redaction', true);",
  "gtag('set', 'url_passthrough', false);",
];

export type GtmContainerConfig = {
  gtmId: string;
  gtmQueryTail?: string;
};

export type BuildGtmLoaderScriptOptions = GtmContainerConfig & {
  pushDataLayerLoadedEvent?: boolean;
};

export const buildGtmConsentDefaultsScript = (): string =>
  [
    'window.dataLayer = window.dataLayer || [];',
    ...GTM_CONSENT_DEFAULT_SCRIPT_LINES,
  ].join('\n');

export const buildGtmLoaderScript = ({
  gtmId,
  gtmQueryTail = '',
  pushDataLayerLoadedEvent = false,
}: BuildGtmLoaderScriptOptions): string => {
  const queryTailLiteral = JSON.stringify(gtmQueryTail);
  const idLiteral = JSON.stringify(gtmId);
  const srcPrefixLiteral = JSON.stringify(GTM_JS_URL_PREFIX);

  const preamble = pushDataLayerLoadedEvent
    ? ["window.dataLayer.push({ event: 'dataLayerLoaded' });"]
    : [];

  return [
    ...preamble,
    '(function (w, d, s, l, i) {',
    '  w[l] = w[l] || [];',
    "  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });",
    '  var f = d.getElementsByTagName(s)[0],',
    '    j = d.createElement(s),',
    "    dl = l != 'dataLayer' ? '&l=' + l : '';",
    '  j.async = true;',
    `  j.src = ${srcPrefixLiteral} + i + dl + ${queryTailLiteral};`,
    '  f.parentNode.insertBefore(j, f);',
    `})(window, document, 'script', 'dataLayer', ${idLiteral});`,
  ].join('\n');
};

export const buildGtmNoscriptIframeSrc = ({
  gtmId,
  gtmQueryTail = '',
}: GtmContainerConfig): string =>
  `https://www.googletagmanager.com/ns.html?id=${gtmId}${gtmQueryTail}`;

export type GtmInlineHeadScript = { children: string };
export type GtmHeadScripts = [GtmInlineHeadScript];

export const buildGtmHeadScripts = (): GtmHeadScripts => [
  { children: buildGtmConsentDefaultsScript() },
];
